module.exports = __webpack_public_path__ + "static/media/received_475766080375655.jpeg23-mobile.09ab79c9.webp";